// extracted by mini-css-extract-plugin
export var button = "InputButton-module--button--a2da3";
export var description = "InputButton-module--description--28724";
export var error = "InputButton-module--error--8b0b6";
export var errorLabel = "InputButton-module--errorLabel--7e79d";
export var focused = "InputButton-module--focused--91fe7";
export var formButton = "InputButton-module--formButton--c979e";
export var icon = "InputButton-module--icon--fa3ac";
export var inputWrapper = "InputButton-module--inputWrapper--407fc";
export var root = "InputButton-module--root--ccc02";